import { useState } from "react";
import type { RouterOutputs } from "@/trpc";
import { ChevronDown, ChevronRight } from "lucide-react";
import { contactDisplay, leadDisplayName } from "@/lib/contact";

type PreselectedLead = RouterOutputs["leads"]["getMany"]["leads"][number];

type Props = {
  leadCount: number;
  // Loaded once by CreateSendModal, which also builds the recipients from them.
  leads: PreselectedLead[];
  isLoading: boolean;
  laneLabel: string;
};

const StepPreselectedAudience = ({ leadCount, leads, isLoading, laneLabel }: Props) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="mb-1 text-lg font-bold">Audiencia preseleccionada</p>
        <p className="text-sm text-gray-600">
          Vas a enviar este mensaje a{" "}
          <span className="font-semibold">{leadCount}</span> leads de{" "}
          <span className="font-semibold">{laneLabel}</span>.
        </p>
      </div>

      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="flex items-center gap-1 self-start text-sm font-medium text-palomma-primary hover:underline"
      >
        {expanded ? (
          <ChevronDown className="size-4" />
        ) : (
          <ChevronRight className="size-4" />
        )}
        {expanded ? "Ocultar lista" : "Ver lista"}
      </button>

      {expanded ? (
        <div className="max-h-72 overflow-y-auto rounded-md border border-gray-200">
          {isLoading ? (
            <div className="p-3 text-xs text-gray-500">Cargando…</div>
          ) : (
            <ul className="divide-y divide-gray-100 text-sm">
              {leads.map((l) => {
                // A phoneless lead reaches this list now, so both columns go
                // through the shared helpers rather than reading `phone`
                // directly — otherwise the row renders blank.
                const contact = contactDisplay(l);

                return (
                  <li
                    key={l.id}
                    className="flex items-center justify-between gap-2 px-3 py-2"
                  >
                    <span className="truncate font-medium text-gray-900">
                      {leadDisplayName(l)}
                    </span>
                    <span className="shrink-0 text-xs text-gray-500">
                      {contact.kind === "none" ? "Sin teléfono" : contact.value}
                    </span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default StepPreselectedAudience;
